import { c as _c } from "react/compiler-runtime";
import { IconSearch } from '@tabler/icons-react';
import { type TabItem, Tabs } from '@xefi/x-react/tabs';
import { type Key, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClearableInput } from '@/components/ClearableInput';
import type { Filter } from '@/models/common';
import { HOME_CONSTANTS } from '../constants';
import { SurveyFilter } from './SurveyFilter';
type TabSurveysProps = {
  activeTab: string;
  setActiveTab: (tab: 'active' | 'closed') => void;
  tabs: TabItem[];
  searchValue: string;
  onSearchChange: (value: string) => void;
  filters: Filter[];
  setFilters: (filters: Filter[]) => void;
  resetSearch: () => void;
};
export const TabSurveys = t0 => {
  const $ = _c(25);
  const {
    activeTab,
    setActiveTab,
    tabs,
    searchValue,
    onSearchChange,
    filters,
    setFilters,
    resetSearch
  } = t0;
  const {
    t
  } = useTranslation();
  const [resetToken] = useState(0);
  const isTabKey = _temp;
  let t1;
  if ($[0] !== setActiveTab) {
    t1 = newKey => {
      if (isTabKey(newKey)) {
        setActiveTab(newKey);
      }
    };
    $[0] = setActiveTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleTabChange = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      tabContent: "shadow-none",
      tabList: "shadow-none",
      panel: "p-0 hidden"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activeTab || $[4] !== handleTabChange || $[5] !== tabs) {
    t3 = <Tabs items={tabs} variant="bordered" onTabChange={handleTabChange} selectedKey={activeTab} classNames={t2} />;
    $[3] = activeTab;
    $[4] = handleTabChange;
    $[5] = tabs;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${t("search", {
    ns: "common"
  })}...`;
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: HOME_CONSTANTS.SEARCH_INPUT_WIDTH,
      inputWrapper: "border-border h-10 !bg-inherit"
    };
    t6 = <IconSearch size={18} className="opacity-70" />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onSearchChange || $[10] !== resetSearch || $[11] !== searchValue || $[12] !== t4) {
    t7 = <ClearableInput placeholder={t4} value={searchValue} onValueChange={onSearchChange} onClear={resetSearch} radius="md" classNames={t5} startContent={t6} />;
    $[9] = onSearchChange;
    $[10] = resetSearch;
    $[11] = searchValue;
    $[12] = t4;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== activeTab || $[15] !== filters || $[16] !== resetToken || $[17] !== setFilters) {
    t8 = activeTab === "active" && <SurveyFilter filters={filters} setFilters={setFilters} resetToken={resetToken} />;
    $[14] = activeTab;
    $[15] = filters;
    $[16] = resetToken;
    $[17] = setFilters;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="flex items-center gap-3">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t9) {
    t10 = <div className="flex items-center justify-between">{t3}{t9}</div>;
    $[22] = t3;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
function _temp(key) {
  return key === "active" || key === "closed";
}